var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.853 11.7759L31.8535 11.7762C32.3474 12.0606 32.7069 12.5476 32.8445 13.1403C32.9825 13.7345 32.8849 14.3847 32.5637 14.9449C32.5636 14.9451 32.5635 14.9453 32.5634 14.9455L23.8525 30.0332C23.1783 31.2009 21.7763 31.5924 20.753 31.0016L14.2338 27.2378C13.3298 26.7159 12.2903 26.4766 11.2492 26.5508L6.14789 26.9145C4.9393 27.0006 4.12583 25.7008 4.73166 24.6514C5.42512 23.4503 5.01359 21.9145 3.81248 21.221L2.04686 20.2016C1.02358 19.6109 0.661628 18.2009 1.33581 17.0332L10.0474 1.9443C10.7216 0.776587 12.1236 0.385093 13.1469 0.975885L31.853 11.7759ZM15.6075 20.814C16.5401 21.3525 17.7327 21.0329 18.2712 20.1002C18.8097 19.1676 18.4901 17.975 17.5575 17.4365L11.885 14.1615C10.9523 13.623 9.75973 13.9426 9.22125 14.8752C8.68278 15.8079 9.00233 17.0005 9.935 17.539L15.6075 20.814ZM22.0149 17.816C22.9475 18.3545 24.1401 18.035 24.6786 17.1023C25.2171 16.1696 24.8975 14.977 23.9649 14.4385L14.785 9.13854C13.8523 8.60007 12.6597 8.91962 12.1213 9.85229C11.5828 10.785 11.9023 11.9776 12.835 12.516L22.0149 17.816Z",
    fill: "#FFEA32",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment_icon.fb79997e9f5c33f24ecee8e03829dd96.svg";
export { ForwardRef as ReactComponent };